import { useEffect, useState } from "react";
import { RadioGroup, RadioGroupItem } from "components/ui/radio-group";
import { Label } from "components/ui/label";

interface FunctionProps {
  datas: string[];
  value: string;
  disabled?: boolean;

  valueChange: (value: string) => void;
}

const SelectGroupRadioOptionSingle = ({ datas, value, valueChange, disabled }: FunctionProps) => {
  const [selected, setSelected] = useState<string>("");

  useEffect(() => {
    setSelected(value);
  }, [value]);

  return (
    <RadioGroup
      className="flex items-center flex-wrap   px-1 outline-none  rounded-none ps-2 pe-2 py-3 min-h-[45px] "
      value={selected}
      defaultValue={selected}
      onValueChange={(value) => {
        setSelected(value);
        valueChange(value);
      }}
    >
      {datas.map((element, index) => (
        <div key={index} className="flex items-center space-x-2 cursor-pointer ">
          <RadioGroupItem disabled={disabled} value={element} id={`${element}_${index}`} />
          <Label className="cursor-pointer" htmlFor={`${element}_${index}`}>
            {element}
          </Label>
        </div>
      ))}
    </RadioGroup>
  );
};

export default SelectGroupRadioOptionSingle;
